import { useState } from 'react';

import type { SaveListItem } from '../../../../types/save-types.js';
import type { IEngagementUIElement } from '@schibsted/pulse-sdk';
import type { PulseContextInputParams } from '../../../../../core/mandatory-integrations/pulse/types/index.js';

import { usePulseContext } from '../../../../../core/mandatory-integrations/pulse/PulseProvider.js';

export function useTeaserSaveOverlay(
  listTeaser: SaveListItem,
  trackObject: PulseContextInputParams<IEngagementUIElement>['object'],
) {
  const [overlay, toggleOverlay] = useState({
    overlayVisible: false,
    itemToSave: listTeaser,
  });

  const { trackClickUIElement } = usePulseContext();

  const handleOverlay = () => {
    trackClickUIElement(
      {
        object: {
          id: trackObject.objectId,
          name: trackObject.name,
          elementType: trackObject.elementType,
        },
      },
      {
        object: {
          ...trackObject,
        },
        placement: { containerName: 'page' },
      },
    );

    toggleOverlay({
      overlayVisible: !overlay.overlayVisible,
      itemToSave: listTeaser,
    });
  };

  const handleSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleOverlay();
  };

  return {
    overlay,
    toggleOverlay,
    handleSave,
    handleOverlay,
  };
}
